export const storeFirstVisit = (value: boolean) => {
  sessionStorage.setItem('FIRST_VISIT', value ? 'true' : 'false');
};

export const isFirstVisit = () => sessionStorage.getItem('FIRST_VISIT') === 'true';

export const removeFirstVisit = () => {
  sessionStorage.removeItem('FIRST_VISIT');
};
